import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render past participants section for FAQ Page
 */
const PastParticipantsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="past-participants-section-component"
    >
      <AccordionV2
        testId="past-participants"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="3. Can past participants apply?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p>
            Yes, past participants can apply. However, if the company was a
            previous winner of any of the award categories (that is, the
            Emerging Enterprise Award or the Best Innovation Award or the Most
            Promising Startup Award), they will then not be eligible to apply
            for this year’s award.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default PastParticipantsSection;
